import { useTestId } from '@cmctechnology/webinvest-design-system';
import { useFrontendContext } from '@cmctechnology/webinvest-store-frontend';
import { watchlistsActions } from '@cmctechnology/webinvest-store-watchlists';
import { accountActions } from '@cmctechnology/webinvest-store-accounts';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { useTimeout } from 'usehooks-ts';
import { IStore } from '../store/store';

const WEB_TRADING_PRELOAD_URL = 'Manage/ProfitLoss';
const WEB_TRADING_PRELOAD_DELAY = 2000;

const HiddenFrame = styled.iframe`
  display: none;
`;

const FetchDataPreLoader: React.FC<{}> = ({}) => {
  const dispatch = useDispatch();
  const selectedAccountId = useSelector((store: IStore) => store.accounts.selected);
  const [pnlPreFetched, setPnlPreFetched] = useState(false);

  useEffect(() => {
    dispatch<any>(watchlistsActions.fetchWatchlists());
    dispatch<any>(accountActions.fetchAccounts());
  }, []);

  useEffect(() => {
    if (selectedAccountId && !pnlPreFetched) {
      setPnlPreFetched(true);
      dispatch<any>(accountActions.fetchProfitLoss(selectedAccountId, true));
    }
  }, [selectedAccountId]);

  return <></>;
};

export const WebTradingPreLoader: React.FC<{}> = ({ ...rest }) => {
  const { generateTestId } = useTestId(rest, 'WebTradingPreLoader');
  const { tradingRoutePrefix } = useFrontendContext();
  const [hide, setHide] = useState(true);

  useTimeout(() => {
    setHide(false);
  }, WEB_TRADING_PRELOAD_DELAY);

  return (
    <>
      {!hide && <HiddenFrame {...generateTestId()} src={`${tradingRoutePrefix}/${WEB_TRADING_PRELOAD_URL}`} onLoad={() => setHide(true)} />}
      <FetchDataPreLoader />
    </>
  );
};
